__turbopack_context__.v({
  "container": "index-module-scss-module__Evg8tq__container",
  "icon": "index-module-scss-module__Evg8tq__icon",
});
